import { render, staticRenderFns } from "./Navigator.vue?vue&type=template&id=b87f5150&"
import script from "./Navigator.vue?vue&type=script&lang=js&"
export * from "./Navigator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports